<template>
  <div
    class="home-header"
    :style="themeStyle"
  >
    <div class="header-img-section">

      <div class="header-title">
        <router-link
          to="/"
          class="header-link"
        >
          <vue-load-image
            v-if="configData.logo && configData.logo.image"
            class="d-flex justify-content-center align-items-center"
          >
            <b-img
              slot="image"
              :src="configData.logo.image"
              fluid
              alt="logo"
            />
            <b-img
              slot="preloader"
              :src="require('@/assets/images/items/loading-2.png')"
              fluid
              alt="logo"
            />
          </vue-load-image>
        </router-link>
      </div>

      <!-- <div
        v-for="n in 100"
        :key="n"
        class="circle-container"
      >
        <div class="circle" />
      </div> -->

    </div>

  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'
import VueLoadImage from 'vue-load-image'

export default {
  components: {
    BImg,
    VueLoadImage,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  mounted() {
    this.themeStyle = this.configData.config
    if (this.configData.logo && this.configData.logo.image) {
      this.configData.logo.image = `${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.logo.image) : this.configData.logo.image}`
    }
  },
  methods: {
    dataSrc(src) {
      return src.split('')[0]
    },
    // (網頁)跳轉
    redirectLink(link) {
      if (!link) return
      window.location.assign(link)
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
}
</script>

<style lang="scss" scoped>
.home-header {
  // padding-bottom: 30px;
  position: relative;
  .header-img-section {
    // min-height: 50vh;
    // height: 100vh;
    .header-title {
      width: 100vw;
      min-height: 200px;
      height: calc(var(--header-height) * 1vh);
      // padding: 10vh 5vh 1vh 5vh;
      display: flex;
      justify-content: center;
      .header-link {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-height: calc(var(--header-height) * 1vh);
        }
      }
    }

  }
}

@media screen and (max-width: 576px){
  .header-img-section {
    height: 100%;
    .header-title {
      padding: 50px 10px !important;
    }
  }
}
</style>
